/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./dx-head-dropdown-tree.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./dx-head-dropdown-tree.component";
var styles_DxHeadDropdownTreeComponent = [i0.styles];
var RenderType_DxHeadDropdownTreeComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_DxHeadDropdownTreeComponent, data: {} });
export { RenderType_DxHeadDropdownTreeComponent as RenderType_DxHeadDropdownTreeComponent };
export function View_DxHeadDropdownTreeComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_DxHeadDropdownTreeComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "dx-head-dropdown-tree", [], null, null, null, View_DxHeadDropdownTreeComponent_0, RenderType_DxHeadDropdownTreeComponent)), i1.ɵdid(1, 245760, null, 0, i2.DxHeadDropdownTreeComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var DxHeadDropdownTreeComponentNgFactory = i1.ɵccf("dx-head-dropdown-tree", i2.DxHeadDropdownTreeComponent, View_DxHeadDropdownTreeComponent_Host_0, { menuNode: "menuNode" }, {}, []);
export { DxHeadDropdownTreeComponentNgFactory as DxHeadDropdownTreeComponentNgFactory };
